import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { injectedConnector, ledgerConnector } from "../utils/connectors";
import { addConnectEvent } from "../utils/analytics";
import { isLedgerDappBrowserProvider } from "web3-ledgerhq-frame-connector";
var useEagerConnect = function () {
    var _a = useWeb3React(), activate = _a.activate, active = _a.active, account = _a.account;
    var _b = useState(false), tried = _b[0], setTried = _b[1];
    useEffect(function () {
        if (tried) {
            return;
        }
        // If is ledger dapp, use ledger connector. Else use injected connector
        if (isLedgerDappBrowserProvider()) {
            activate(ledgerConnector, undefined, true).catch(function () {
                setTried(true);
            });
        }
        else {
            injectedConnector.isAuthorized().then(function (isAuthorized) {
                if (isAuthorized) {
                    activate(injectedConnector, undefined, true).catch(function () {
                        setTried(true);
                    });
                }
                else {
                    setTried(true);
                }
            });
        }
    }, [activate, tried]); // intentionally only running on mount (make sure it's only mounted once :))
    // if the connection worked, wait until we get confirmation of that to flip the flag
    useEffect(function () {
        if (!tried && active) {
            if (account) {
                addConnectEvent("background", account);
            }
            setTried(true);
        }
    }, [tried, active, activate, account]);
    return tried;
};
export default useEagerConnect;
//# sourceMappingURL=useEagerConnect.js.map